import { query } from "firebase/firestore";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { queryAllDocsByFieldSnap } from "../../utils/firebase/Firebase.utils";
import { Link } from "react-router-dom";
import UserScreenWindow from "../User/Components/UserScreenWindow";
import GatepassCard from "./GatepassCard";
import { useNavigate } from "react-router-dom";
import WorkPermitCard from "../Dashboard/AdminDashboard/WorkPermitCard";
import PageModal from "../Dashboard/Components/PageModal";
import WorkPermitDetails from "../Dashboard/WorkPermits/WorkPermitDetails";

function ContractorWorkPermit() {
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.userObject);
  const [workPermits, setWorkPermits] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const [selectedPermit, setSelectedPermit] = useState(null);
  const [viewMode, setViewMode] = useState(false);

  useEffect(() => {
    const fetchWorkPermits = async () => {
      await queryAllDocsByFieldSnap(
        "workPermits",
        "createdBy",
        "==",
        currentUser.email,
        (data) => {
          setWorkPermits(data);
          setLoading(false);
        }
      );
    };
    fetchWorkPermits();
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  const handleCardClick = (permit) => {
    setViewMode(true);
    setSelectedPermit(permit);
  };

  const handleAddNew = () => {
    navigate("/admin/mobile/add-work-permit");
  };

  return (
    <UserScreenWindow label="Contractor Work Permits">
      <div>
        <h1 className="title-header">Contractor Work Permits </h1>

        <div className="mt-4">
          <button
            className="btn btn-primary blue-button"
            onClick={handleAddNew}
          >
            Add New Work Permit
          </button>
        </div>

        <div className="mt-4">
          {workPermits.map((permit, index) => (
            <div key={index}>
              <WorkPermitCard
                permit={permit}
                onClick={() => handleCardClick(permit)}
              />
            </div>
          ))}
        </div>
      </div>

      {viewMode && (
        <PageModal>
          <WorkPermitDetails
            application={selectedPermit}
            setViewMode={setViewMode}
          />
        </PageModal>
      )}
    </UserScreenWindow>
  );
}

export default ContractorWorkPermit;
